var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProjects(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 9.33333C14.0697 9.33333 14.6667 8.73638 14.6667 8C14.6667 7.26362 14.0697 6.66667 13.3333 6.66667C12.597 6.66667 12 7.26362 12 8C12 8.73638 12.597 9.33333 13.3333 9.33333Z",
    stroke: "#6E6E6E",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 4C14.0697 4 14.6667 3.40305 14.6667 2.66667C14.6667 1.93029 14.0697 1.33333 13.3333 1.33333C12.597 1.33333 12 1.93029 12 2.66667C12 3.40305 12.597 4 13.3333 4Z",
    stroke: "#6E6E6E",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 14.6667C14.0697 14.6667 14.6667 14.0697 14.6667 13.3333C14.6667 12.597 14.0697 12 13.3333 12C12.597 12 12 12.597 12 13.3333C12 14.0697 12.597 14.6667 13.3333 14.6667Z",
    stroke: "#6E6E6E",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.66683 9.33333C3.40321 9.33333 4.00016 8.73638 4.00016 8C4.00016 7.26362 3.40321 6.66667 2.66683 6.66667C1.93045 6.66667 1.3335 7.26362 1.3335 8C1.3335 8.73638 1.93045 9.33333 2.66683 9.33333Z",
    stroke: "#6E6E6E",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4 8H12",
    stroke: "#6E6E6E",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0002 2.66667H9.3335C8.00016 2.66667 7.3335 3.33333 7.3335 4.66667V11.3333C7.3335 12.6667 8.00016 13.3333 9.3335 13.3333H12.0002",
    stroke: "#6E6E6E",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjects);
export default __webpack_public_path__ + "static/media/projects.3ce595881b4f685b3cc72a82514ebf4b.svg";
export { ForwardRef as ReactComponent };